import { memo } from 'react';
import { motion } from 'motion/react';
import { useGetParams } from '../../hooks/useGetParams';
import styles from './Advt.module.css';

import posterDefault from '../../assets/images/advtBgPoster.webp';
import bgDefaultVideo from '../../assets/video/advtBg.webm';
import logo from '../../assets/images/logo.png';

const Advt = memo(() => {
  const { title, qrCode1, qrCode2, paddingQR, sizeQR, titleFontSize } =
    useGetParams();

  const letters = title
    ?.trim()
    ?.split('')
    ?.map((char) => (char === ' ' ? '\u00A0' : char));

  return (
    <div className={styles.wrapper}>
      <motion.div
        initial={{ scale: 0, y: '25vh' }}
        animate={{ scale: [0, 1.1, 1], y: 0 }}
        transition={{
          scale: {
            duration: 0.77,
            times: [0, 0.87, 1],
          },
          y: {
            delay: 2.3,
            duration: 0.7,
          },
        }}
        className={styles.logoAndTitle}
      >
        <img src={logo} alt="logo" className={styles.logo} />
        {letters && (
          <div className={styles.title}>
            {letters.map((l, idx) => (
              <motion.div
                key={l + idx}
                initial={{ scaleX: 5, filter: 'blur(5px)' }}
                animate={{ scaleX: 1, filter: 'blur(0px)' }}
                transition={{
                  duration: 0.08,
                  delay: 0.8 + 0.04 * idx,
                }}
                style={{ fontSize: `${titleFontSize}rem` }}
              >
                <div>{l}</div>
              </motion.div>
            ))}
          </div>
        )}
      </motion.div>

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: { duration: 0.66, delay: 3 },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: { duration: 0.66, delay: 3 + 0.4 },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode2" />
          </motion.div>
        )}
      </div>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.bgVideo}
        poster={posterDefault}
      >
        <source src={bgDefaultVideo} type="video/webm" />
      </video>
    </div>
  );
});

export default Advt;
